import { Headers } from 'shared/components/ui/task-card-task-section';
import { DateSectionOptions } from 'shared/types/orderable-section';

export const sectionTypeToHeaderMap: Record<
  DateSectionOptions,
  Headers | undefined
> = {
  [DateSectionOptions.Day]: Headers.Date,
  [DateSectionOptions.RestOfMonth]: undefined,
  [DateSectionOptions.Month]: Headers.Month,
  [DateSectionOptions.Year]: Headers.Year,
};
